import React from 'react'




export const Stars=({ fill = 0 })=>{
    return (
         <div className="relative text-[28px] inline-block">
      {/* Empty star */}
      <span className="text-gray-300">★</span>

      {/* Filled part */}
      <span
        className="absolute top-0 left-0 overflow-hidden text-yellow-400"
        style={{ width: `${fill * 100}%` }}
      >
        ★
      </span>
    </div>
    )
}


export const Rating = ({rating}) => {
     const stars = [0, 1, 2, 3, 4]; // 5 stars

  const getFill = (index) => {
    if (rating >= index + 1) return 1; // full star
    if (rating >= index + 0.5) return 0.5; // half star
    return 0; // empty
  };
  return (
  <div className="flex gap-1">
      {stars.map((index) => (
        <Stars key={index} fill={getFill(index)} />
      ))}
    </div>
  )
}


